import {
  MY_PROFILE,
  LEAVE_FOR_EMPLOYEE,
  APPRAISAL,
  APPR_PARAM,
  APPROVAL_WORKFLOW,
  COMP_OFF_CONFIG,
  EMP_CODE_CONFIG,
  SECTION,
  UNIT,
  ATTENDANCE_FOR_EMPLOYEE,
  EMPLOYEE_ATTENDANCE,
  EMPLOYEE_LEAVE,
  TEAM_ATTENDANCE,
  CALENDAR,
  DEPARTMENT,
  DESIGNATION,
  EMPLOYEE,
  EMPLOYEE_PAYROLL,
  EMPLOYEE_USER_MAPPING,
  EMP_TYPE,
  EMPLOYMENT_STATUS,
  GRADES,
  HOLIDAY,
  INCREMENT,
  LEAVE_TYPE,
  COMP_OFF_FOR_EMPLOYEE,
  ATTENDANCE_REQUEST,
  MY_LEAVE,
  OFFICE_LOCATION,
  PAYROLL_BANK_CONFIG,
  PAYROLL_ELM,
  SHIFTS,
  WEEKEND,
  PAYROLL_RUNS,
  TAX_CONFIG,
  PROVIDENT_FUND,
  GRATUITY_FUND,
  ATTENDANCE_PAY,
  AMOUNT_ROUNDING,
  MY_PAYSLIPS,
  ALL_PAYSLIPS,
  MY_TAX_CERT,
  MY_PF,
  MY_GF,
  MY_COMP_OFF,
  ALL_TAX_CERT,
  PROMOTION,
  SEPARATION,
  LOAN_ADVANCE,
  MY_LOANS,
  RPT_EMPLOYEE,
  RPT_APPRAISAL,
  RPT_PAYROLL,
  RPT_ATTN_SUMMARY,
  RPT_MONTHLY_ATTENDANCE,
  RPT_PF,
  RPT_GF,
  RPT_TAX_CERT,
  MY_REQUESTS,
  PENDING_APPROVALS,
} from '@constants/internal-route.constant'

// Child feature routes under each sidebar group. A group is hidden unless the user is granted at
// least one of its children, so an employee never sees an empty Payroll / Settings / Reports
// group. Each list must hold exactly the `to` values rendered inside that group.

// ESS (Employee Self Service) — every "My …" self-service page, grouped under /ess.
export const ESS_ROUTES = [
  MY_PROFILE,
  MY_LEAVE,
  MY_LOANS,
  MY_PAYSLIPS,
  MY_TAX_CERT,
  MY_PF,
  MY_GF,
  MY_COMP_OFF,
  ATTENDANCE_REQUEST,
  TEAM_ATTENDANCE,
]

export const HRM_ROUTES = [
  EMPLOYEE,
  EMPLOYEE_USER_MAPPING,
  INCREMENT,
  PROMOTION,
  SEPARATION,
  LOAN_ADVANCE,
  ALL_PAYSLIPS,
  ALL_TAX_CERT,
  APPRAISAL,
]

export const LEAVE_ATTN_ROUTES = [
  LEAVE_FOR_EMPLOYEE,
  ATTENDANCE_FOR_EMPLOYEE,
  EMPLOYEE_ATTENDANCE,
  EMPLOYEE_LEAVE,
  LEAVE_TYPE,
  COMP_OFF_FOR_EMPLOYEE,
]

export const PAYROLL_ROUTES = [
  PAYROLL_ELM,
  AMOUNT_ROUNDING,
  ATTENDANCE_PAY,
  TAX_CONFIG,
  PROVIDENT_FUND,
  GRATUITY_FUND,
  PAYROLL_BANK_CONFIG,
  EMPLOYEE_PAYROLL,
  PAYROLL_RUNS,
]

// Approvals: what I filed, and what waits on my decision (every document type in one queue).
export const APPROVAL_ROUTES = [MY_REQUESTS, PENDING_APPROVALS]

export const SETTINGS_ROUTES = [
  OFFICE_LOCATION,
  DEPARTMENT,
  DESIGNATION,
  GRADES,
  EMP_TYPE,
  EMPLOYMENT_STATUS,
  SHIFTS,
  WEEKEND,
  HOLIDAY,
  CALENDAR,
  APPR_PARAM,
  APPROVAL_WORKFLOW,
  COMP_OFF_CONFIG,
  EMP_CODE_CONFIG,
  SECTION,
  UNIT,
]

export const REPORTS_ROUTES = [
  RPT_EMPLOYEE,
  RPT_APPRAISAL,
  RPT_PAYROLL,
  RPT_ATTN_SUMMARY,
  RPT_MONTHLY_ATTENDANCE,
  RPT_PF,
  RPT_GF,
  RPT_TAX_CERT,
]
